import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.15_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.15_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/blur-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/vercel/path0/src/components/shared/copy-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/mdx.css");
